/**
 * Imports
 */
import { createReducer } from '@reduxjs/toolkit';

import {
  collapseSidebar,
  hideSidebar,
  openSidebar,
  showAddTerminalModal,
  hideAddTerminalModal,
} from './actions';

/**
 * Types
 */
export interface SidebarState {
  visible: boolean;
  collapsed: boolean;
  modals: {
    terminalModal: boolean;
  };
}

/**
 * Constants
 */
const INITIAL_STATE: SidebarState = {
  visible: true,
  collapsed: false,
  modals: {
    terminalModal: false,
  },
};

/**
 * `sidebar` reducer
 */
const sidebarReducer = createReducer(INITIAL_STATE, {
  /**
   * COLLAPSE_SIDEBAR
   */
  [collapseSidebar.type]: (state) => {
    state.collapsed = true;
  },
  /**
   * HIDE_SIDEBAR
   */
  [hideSidebar.type]: (state) => {
    state.visible = false;
  },
  /**
   * OPEN_SIDEBAR
   */
  [openSidebar.type]: (state) => {
    state.collapsed = false;
    state.visible = true;
  },
  /**
   * SHOW_OWNER_MODAL
   */
  [showAddTerminalModal.type]: (state) => {
    state.modals.terminalModal = true;
  },
  /**
   * HIDE_OWNER_MODAL
   */
  [hideAddTerminalModal.type]: (state) => {
    state.modals.terminalModal = false;
  },
});

/**
 * Exports
 */
export default sidebarReducer;
